import React from "react";
import Dropdown from 'react-bootstrap/Dropdown';
import { useAuth } from "../../../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import * as PROFILE from "../../../../constants/profile"
import './Sidebar.scss'

const Sidebar = () => {
  const navigate = useNavigate();
  const { hasPermission, user } = useAuth();

  const sidebarTemplate = (
    <>
      <nav className="app-sidebar">
        <Dropdown.Menu show>        
          {
            (
              hasPermission(PROFILE.PERMISSIONS.SERVICES_REPORT) ||
              hasPermission(PROFILE.PERMISSIONS.WEEKLY_PRODUCTION_REPORT) ||
              hasPermission(PROFILE.PERMISSIONS.DRIVER_REPORT) ||
              hasPermission(PROFILE.PERMISSIONS.DRIVER_PAYMENT_REPORT) ||
              hasPermission(PROFILE.PERMISSIONS.INCOME_REEPORT) || 
              hasPermission(PROFILE.PERMISSIONS.ROUTES_REPORT) ||
              hasPermission(PROFILE.PERMISSIONS.PAYMENT_ORDER_REPORT)              
            ) && (
              <>
                <Dropdown.Header>
                  <small>
                    REPORTES
                  </small>
                </Dropdown.Header>
              </>
            )
          }
          {/* 
                <Dropdown.Item
                  eventKey="pollsReport"
                  className="ps-4"
                  onClick={() => navigate("/pollsReport")}>
                  Reporte de encuestas
                </Dropdown.Item> 
          */}              
          {
            hasPermission(PROFILE.PERMISSIONS.SERVICES_REPORT) && (
              <>
                <Dropdown.Item
                  eventKey="servicesReport"
                  className="ps-4"
                  onClick={() => navigate("servicesReport")}>
                  Reporte de Servicios
                </Dropdown.Item>                        
              </>
            )
          }
          {
            hasPermission(PROFILE.PERMISSIONS.WEEKLY_PRODUCTION_REPORT) && (
              <>
                <Dropdown.Item
                  eventKey="weeklyProduction"
                  className="ps-4"
                  onClick={() => navigate("weeklyProduction")}>
                  Producción Semanal
                </Dropdown.Item>
              </>
            )
          }       
          {
            hasPermission(PROFILE.PERMISSIONS.DRIVER_REPORT) && (
              <>
                <Dropdown.Item
                  eventKey="driverReport"
                  className="ps-4"
                  onClick={() => navigate("driverReport")}>
                  Reporte Historial
                </Dropdown.Item>
              </>
            )
          }
          {
            hasPermission(PROFILE.PERMISSIONS.DRIVER_PAYMENT_REPORT) && (
              <>
                <Dropdown.Item
                  eventKey="driverPaymentReport"
                  className="ps-4"
                  onClick={() => navigate("driverPaymentReport")}>
                  Reporte por Operador
                </Dropdown.Item>
              </>
            )
          } 
          {
            hasPermission(PROFILE.PERMISSIONS.INCOME_REEPORT) && (
              <>
                <Dropdown.Item
                  eventKey="incomeReport"
                  className="ps-4"
                  onClick={() => navigate("incomeReport")}>
                  Reporte de Ingresos
                </Dropdown.Item>
              </>
            )
          }
          {
            hasPermission(PROFILE.PERMISSIONS.PAYMENT_ORDER_REPORT) && (
              <>
                <Dropdown.Item
                  eventKey="incomeReport"
                  className="ps-4"
                  onClick={() => navigate("paymentOrderReport")}>
                  Reporte de Caja
                </Dropdown.Item>
              </>
            )
          } 
          {
            hasPermission(PROFILE.PERMISSIONS.ROUTES_REPORT) && (
              <>
                <Dropdown.Item
                  eventKey="routesReport"
                  className="ps-4"
                  onClick={() => navigate("routesReport")}>
                  Reporte de Rutas
                </Dropdown.Item>
              </>
            )
          } 
          {
            hasPermission(PROFILE.PERMISSIONS.ROUTES_REPORT_BY_STATUS) && (
              <>
                <Dropdown.Item
                  eventKey="routesReportByStatus"
                  className="ps-4"
                  onClick={() => navigate("routesReportByStatus")}>
                  Reporte de Rutas por Estatus
                </Dropdown.Item>
              </>
            )
          }           
          {
            (
              hasPermission(PROFILE.PERMISSIONS.ASSIGNMENT) ||
              hasPermission(PROFILE.PERMISSIONS.ASSIGNMENT_BY_DRIVER)
            ) && (
              <>
                <Dropdown.Header>
                  <small>
                    ASIGNACIÓN
                  </small>
                </Dropdown.Header>
              </>
            )
          }
          {
            hasPermission(PROFILE.PERMISSIONS.ASSIGNMENT) && (
              <>
                <Dropdown.Item
                  eventKey="assignment"
                  className="ps-4"
                  onClick={() => navigate("assignment")}>
                  Asignación
                </Dropdown.Item>
              </>
            )
          }
          {
            hasPermission(PROFILE.PERMISSIONS.ASSIGNMENT_BY_DRIVER) && (
              <>
                <Dropdown.Item
                  eventKey="driverAssignment"
                  className="ps-4"
                  onClick={() => navigate("driverAssignment")}>
                  Asignación por Conductor
                </Dropdown.Item>  
              </>
            )
          }
          {
            hasPermission(PROFILE.PERMISSIONS.UPLOAD_SALE) && (
              <>
                <Dropdown.Header>
                  <small>
                    SUBIR ARCHIVOS
                  </small>
                </Dropdown.Header>
                <Dropdown.Item
                  eventKey="uploadSale"
                  className="ps-4"
                  onClick={() => navigate("uploadSale")}>
                  Subir Venta
                </Dropdown.Item>
              </>
            )
          }
          {
            hasPermission(PROFILE.PERMISSIONS.CATALOGS) && (
              <>
                <Dropdown.Header>
                  <small>
                    CATÁLOGOS
                  </small>
                </Dropdown.Header>
                <Dropdown.Item
                  eventKey="users"
                  className="ps-4"
                  onClick={() => navigate("users")}>
                  Usuarios
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="profiles"
                  className="ps-4"
                  onClick={() => navigate("profiles")}>
                  Perfiles
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="vehicles"
                  className="ps-4"
                  onClick={() => navigate("vehicles")}>
                  Vehículos
                </Dropdown.Item>
                {/* <Dropdown.Item
                  eventKey="drivers"
                  className="ps-4"
                  onClick={() => navigate("drivers")}>
                  Conductores
                </Dropdown.Item> */}
                <Dropdown.Item
                  eventKey="labels"
                  className="ps-4"
                  onClick={() => navigate("labels")}>
                  Etiquetas
                </Dropdown.Item>
              </>
            )
          }
          {
            (
              hasPermission(PROFILE.PERMISSIONS.MAINTENANCE_LOG_REPORT) ||
              hasPermission(PROFILE.PERMISSIONS.ADD_EDIT_MAINTENANCE_LOG) ||
              hasPermission(PROFILE.PERMISSIONS.MAINTENANCE_CATALOGS)
            ) && (
              <>
                <Dropdown.Header>
                  <small>
                    MANTENIMIENTO
                  </small>
                </Dropdown.Header>
              </>
            )
          }
          {
            hasPermission(PROFILE.PERMISSIONS.MAINTENANCE_LOG_REPORT) && (
              <>
                <Dropdown.Item
                  eventKey="labels"
                  className="ps-4"
                  onClick={() => navigate("maintenanceLogReport")}>
                  Bitácora de Mantenimientos
                </Dropdown.Item>
              </>
            )
          }
          {
            hasPermission(PROFILE.PERMISSIONS.MAINTENANCE_CATALOGS) && (
              <>
                <Dropdown.Item
                  eventKey="labels"
                  className="ps-4"
                  onClick={() => navigate("serviceTypes")}>
                  Tipos de Servicio
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="labels"
                  className="ps-4"
                  onClick={() => navigate("serviceTypeConcepts")}>
                  Conceptos de Servicio
                </Dropdown.Item>
              </>
            )
          }
        </Dropdown.Menu>
      </nav>
    </>
  );

  return (
    <> 
      {
        user && sidebarTemplate
      }      
    </>
  )
}

export default Sidebar;